import * as _ from 'lodash'
import {
    IGraphAxis,
    IGraphMetric,
    IGraphMetricComponent,
    IGraphAxisRenderOptions,
    IGraphMetricRenderOptions,
    IGraphMetricComponentRenderOptions
} from "./PA.UIM.Graph.IF";
import { IPeriod, IPeriodMetrics } from "./PA.UIM.Metric.IF";
import { IMetrics } from "../PA.Metric.Services/PA.Metrics.IF";

const mtrc: IMetrics = undefined
const pm: IPeriodMetrics = undefined

//
// Define Metrics for each Axis
//

//<editor-fold desc="Consumer Units Axis">

//<editor-fold desc="Consumer Units Axis - Metrics">

const CNSMP_INCR_UNITS_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_UNITS_UseBounds",
    name: "Merch Incr Units",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_INCR_UNITS_Event",
            name: "InsideBounds Merch Incr Units",
            metricFieldName: "CNSMP_INCR_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_UNITS_Event": '*' },
                        properties: { color: "#CBF4C9" },
                        displayName: "Event Merch Incr Units"
                    }
                }
            }
        },
        {
            id: "CNSMP_INCR_UNITS_OutsideBounds",
            name: "OutsideBounds Merch Incr Units",
            metricFieldName: "CNSMP_INCR_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_UNITS_OutsideBounds": '*' },
                        properties: { color: "#CBF4C9", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Merch Incr Units"
                    }
                }
            }
        }
    ]
}

const CNSMP_DISP_INCR_UNITS_UseBounds: IGraphMetric = {
    id: "CNSMP_DISP_INCR_UNITS_UseBounds",
    name: "Display Incr Units",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_DISP_INCR_UNITS_InsideBounds",
            name: "InsideBounds Display Incr Units",
            metricFieldName: "CNSMP_DISP_INCR_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_UNITS_Event": '*' },
                        properties: { color: "#0092B2" },
                        displayName: "Event Disp Incr Units"
                    }
                }
            }
        },
        {
            id: "CNSMP_DISP_INCR_UNITS_OutsideBounds",
            name: "OutsideBounds Display Incr Units",
            metricFieldName: "CNSMP_DISP_INCR_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_UNITS_OutsideBounds": '*' },
                        properties: { color: "#0092B2", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Disp Incr Units"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_UNITS_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_UNITS_UseBounds",
    name: "EDLP Units",
    sort: 20,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_EDLP_UNITS_InsideBounds",
            name: "InsideBounds EDLP Units",
            metricFieldName: "CNSMP_EDLP_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_UNITS_InsideBounds": '*' },
                        properties: { color: "#0080FF" },
                        displayName: "Event EDLP Units"
                    }
                }
            }
        },
        {
            id: "CNSMP_EDLP_UNITS_OutsideBounds",
            name: "OutsideBounds EDLP Units",
            metricFieldName: "CNSMP_EDLP_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_UNITS_OutsideBounds": '*' },
                        properties: { color: "#0080FF", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event EDLP Units"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_UNITS_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_UNITS_UseBounds",
    name: "True Base Units",
    sort: 40,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_BASE_UNITS_InsideBounds",
            name: "InsideBounds Base Units",
            metricFieldName: "CNSMP_BASE_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_UNITS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Base Units"
                    }
                }
            }
        },
        {
            id: "CNSMP_BASE_UNITS_OutsideBounds",
            name: "OutsideBounds Base Units",
            metricFieldName: "CNSMP_BASE_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_UNITS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Base Units"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_UNITS_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_UNITS_UseBounds",
    name: "Synd Base Units",
    sort: 30,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_SYND_BASE_UNITS_InsideBounds",
            name: "InsideBounds Synd Base Units",
            metricFieldName: "CNSMP_SYND_BASE_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_UNITS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Synd Base Units"
                    }
                }
            }
        },
        {
            id: "CNSMP_SYND_BASE_UNITS_OutsideBounds",
            name: "OutsideBounds Synd Base Units",
            metricFieldName: "CNSMP_SYND_BASE_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_UNITS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Synd Base Units"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const StdUnitsAxis: IGraphAxis = {
    id: "Units",
    name: "Consumer Units",
    renderOptions: {
        ui5: {
            resourceName: "StandardConsumerUnitsAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Consumer Units"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_UNITS_UseBounds, CNSMP_DISP_INCR_UNITS_UseBounds, CNSMP_EDLP_UNITS_UseBounds, CNSMP_BASE_UNITS_UseBounds, CNSMP_SYND_BASE_UNITS_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_UNITS_UseBounds.id,
        CNSMP_DISP_INCR_UNITS_UseBounds.id,
        CNSMP_EDLP_UNITS_UseBounds.id,
        CNSMP_BASE_UNITS_UseBounds.id
    ]


}

//</editor-fold>

//<editor-fold desc="Price Axis">

//<editor-fold desc="Price Axis - Metrics">

export const CNSMP_RETAILER_BASE_PRICE: IGraphMetric = {
    id: "CNSMP_RETAILER_BASE_PRICE",
    name: "Base Price",
    sort: 200,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_RETAILER_BASE_PRICE",
            name: "Base Price",
            metricFieldName: "RETAILER_BASE_PRICE",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "CNSMP_RETAILER_BASE_PRICE": '*' },
                        properties: { color: "#A59487", lineColor: "#A59487", lineType: "line" },
                        displayName: "Base Price"
                    }
                }
            }
        }
    ]
}

export const CNSMP_RETAILER_PROMOTED_PRICE: IGraphMetric = {
    id: "CNSMP_RETAILER_PROMOTED_PRICE",
    name: "Promoted Price",
    sort: 220,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_RETAILER_PROMOTED_PRICE",
            name: "Promoted Price",
            metricFieldName: "RETAILER_PROMOTED_PRICE",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "CNSMP_RETAILER_PROMOTED_PRICE": '*' },
                        properties: { color: "#CBF4C9", lineColor: "#CBF4C9", lineType: "line" },
                        displayName: "Promoted Price"
                    }
                }
            }
        }
    ]
}

export const CNSMP_RETAILER_AVG_PRICE: IGraphMetric = {
    id: "CNSMP_RETAILER_AVG_PRICE",
    name: "Average Price",
    sort: 240,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_RETAILER_AVG_PRICE",
            name: "Average Price",
            metricFieldName: "RETAILER_AVG_PRICE",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "CNSMP_RETAILER_AVG_PRICE": '*' },
                        properties: { color: "#0080FF", lineColor: "#0080FF", lineType: "line" },
                        displayName: "Average Price"
                    }
                }
            }
        }
    ]
}

export const CNSMP_LIST_PRICE: IGraphMetric = {
    id: "CNSMP_LIST_PRICE",
    name: "List Price",
    sort: 260,
    renderOptions: { ui5: { resourceName: "mtrcListPrice" } },
    components: [
        {
            id: "CNSMP_LIST_PRICE",
            name: "List Price",
            metricFieldName: "LIST_PRICE",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "CNSMP_LIST_PRICE": '*' },
                        properties: { color: "#91FFBA", lineColor: "#91FFBA", lineType: "line" },
                        displayName: "List Price"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const StdPricesAxis: IGraphAxis = {
    id: "Prices",
    name: "Prices",
    renderOptions: {
        ui5: {
            resourceName: "StandardPricesAxisName",
            vizPropertiesAxis: {
                label: {
                    formatString: "0.00"
                },
                title: {
                    visible: true,
                    text: "Price"
                }
            },
            vizPropertiesPlotArea: {
                "line": { "marker": { "shape": "diamond" } }
            }
        }
    },
    metrics: [CNSMP_RETAILER_BASE_PRICE, CNSMP_RETAILER_PROMOTED_PRICE, CNSMP_RETAILER_AVG_PRICE, CNSMP_LIST_PRICE],
    defaultRenderedMetricIds: [
        CNSMP_RETAILER_BASE_PRICE.id,
        CNSMP_RETAILER_PROMOTED_PRICE.id,
        CNSMP_RETAILER_AVG_PRICE.id]

}

//</editor-fold>


//<editor-fold desc="Merchandising Units Axis">


//<editor-fold desc="Merchandising Units Axis - Metrics">

//mtrc.MERCH_FEATUREDISPLAY_UNITS
const MERCH_FEATUREDISPLAY_UNITS_UseBounds: IGraphMetric = {
    id: "MERCH_FEATUREDISPLAY_UNITS_UseBounds",
    name: "F&D Units",
    sort: 5,
    renderOptions: {},
    components: [
        {
            id: "MERCH_FEATUREDISPLAY_UNITS_InsideBounds",
            name: "InsideBounds F&D Units",
            metricFieldName: "MERCH_FEATUREDISPLAY_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREDISPLAY_UNITS_InsideBounds": '*' },
                        properties: { color: "#B03BB2" },
                        displayName: "Event F&D Units"
                    }
                }
            }
        },
        {
            id: "MERCH_FEATUREDISPLAY_UNITS_OutsideBounds",
            name: "OutsideBounds F&D Units",
            metricFieldName: "MERCH_FEATUREDISPLAY_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREDISPLAY_UNITS_OutsideBounds": '*' },
                        properties: { color: "#B03BB2", pattern: "diagonalStripe" },
                        displayName: "Non-Event F&D Units"
                    }
                }
            }
        }
    ]
}

//mtrc.MERCH_FEATUREONLY_UNITS
const MERCH_FEATUREONLY_UNITS_UseBounds: IGraphMetric = {
    id: "MERCH_FEATUREONLY_UNITS_UseBounds",
    name: "Feat Units",
    sort: 7,
    renderOptions: {},
    components: [
        {
            id: "MERCH_FEATUREONLY_UNITS_InsideBounds",
            name: "InsideBounds Feat Units",
            metricFieldName: "MERCH_FEATUREONLY_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREONLY_UNITS_InsideBounds": '*' },
                        properties: { color: "#7CFF9F" },
                        displayName: "Event Feat Units"
                    }
                }
            }
        },
        {
            id: "MERCH_FEATUREONLY_UNITS_OutsideBounds",
            name: "OutsideBounds Feat Units",
            metricFieldName: "MERCH_FEATUREONLY_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREONLY_UNITS_OutsideBounds": '*' },
                        properties: { color: "#7CFF9F", pattern: "diagonalStripe" },
                        displayName: "Non-Event Feat Units"
                    }
                }
            }
        }
    ]
}

//mtrc.MERCH_DISPLAYONLY_UNITS
const MERCH_DISPLAYONLY_UNITS_UseBounds: IGraphMetric = {
    id: "MERCH_DISPLAYONLY_UNITS_UseBounds",
    name: "Disp Units",
    sort: 9,
    renderOptions: {},
    components: [
        {
            id: "MERCH_DISPLAYONLY_UNITS_InsideBounds",
            name: "InsideBounds Disp Units",
            metricFieldName: "MERCH_DISPLAYONLY_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_DISPLAYONLY_UNITS_InsideBounds": '*' },
                        properties: { color: "#0092B2" },
                        displayName: "Event Disp Units"
                    }
                }
            }
        },
        {
            id: "MERCH_DISPLAYONLY_UNITS_OutsideBounds",
            name: "OutsideBounds Disp Units",
            metricFieldName: "MERCH_DISPLAYONLY_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_DISPLAYONLY_UNITS_OutsideBounds": '*' },
                        properties: { color: "#0092B2", pattern: "diagonalStripe" },
                        displayName: "Non-Event Disp Units"
                    }
                }
            }
        }
    ]
}

//mtrc.MERCH_TPRONLY_UNITS
const MERCH_TPRONLY_UNITS_UseBounds: IGraphMetric = {
    id: "MERCH_TPRONLY_UNITS_UseBounds",
    name: "TPR Units",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "MERCH_TPRONLY_UNITS_InsideBounds",
            name: "InsideBounds TPR Units",
            metricFieldName: "MERCH_TPRONLY_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_TPRONLY_UNITS_InsideBounds": '*' },
                        properties: { color: "#FF7800" },
                        displayName: "Event TPR Units"
                    }
                }
            }
        },
        {
            id: "MERCH_TPRONLY_UNITS_OutsideBounds",
            name: "OutsideBounds TPR Units",
            metricFieldName: "MERCH_TPRONLY_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_TPRONLY_UNITS_OutsideBounds": '*' },
                        properties: { color: "#FF7800", pattern: "diagonalStripe" },
                        displayName: "Non-Event TPR Units"
                    }
                }
            }
        }
    ]
}


//</editor-fold>


export const StdMerchadisingUnitsAxis: IGraphAxis = {
    id: "MerchandisingUnits",
    name: "Merchandising Units",
    renderOptions: {
        ui5: {
            resourceName: "StandardMerchandisingUnitsAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Merch Units"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [
        MERCH_FEATUREDISPLAY_UNITS_UseBounds,
        MERCH_FEATUREONLY_UNITS_UseBounds,
        MERCH_DISPLAYONLY_UNITS_UseBounds,
        MERCH_TPRONLY_UNITS_UseBounds
    ],
    defaultRenderedMetricIds: [
        MERCH_FEATUREDISPLAY_UNITS_UseBounds.id,
        MERCH_FEATUREONLY_UNITS_UseBounds.id,
        MERCH_DISPLAYONLY_UNITS_UseBounds.id,
        MERCH_TPRONLY_UNITS_UseBounds.id
    ]

}

//</editor-fold>

//<editor-fold desc="Merchandising ACV Axis">

//<editor-fold desc="Merchandising ACV Axis - Metrics">


//mtrc.MERCH_FEATUREDISPLAY_ACV_PCNT Bounds
export const MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds: IGraphMetric = {
    id: "MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds",
    name: "F&D ACV",
    sort: 5,
    renderOptions: {},
    components: [
        {
            id: "MERCH_FEATUREDISPLAY_ACV_PCNT_InsideBounds",
            name: "InsideBounds F&D ACV",
            metricFieldName: "MERCH_FEATUREDISPLAY_ACV_PCNT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREDISPLAY_ACV_PCNT_InsideBounds": '*' },
                        properties: { color: "#B03BB2", lineColor: "#B03BB2", lineType: "line" },
                        displayName: "Event F&D ACV"
                    }
                }
            }
        },
        {
            id: "MERCH_FEATUREDISPLAY_ACV_PCNT_OutsideBounds",
            name: "OutsideBounds F&D ACV",
            metricFieldName: "MERCH_FEATUREDISPLAY_ACV_PCNT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREDISPLAY_ACV_PCNT_OutsideBounds": '*' },
                        properties: { color: "#B03BB2", lineColor: "#B03BB2", lineType: "line", pattern: "noFill" },
                        displayName: "Non-Event F&D ACV"
                    }
                }
            }
        }
    ]
}

//mtrc.MERCH_FEATUREONLY_ACV_PCNT Bounds
const MERCH_FEATUREONLY_ACV_PCNT_UseBounds: IGraphMetric = {
    id: "MERCH_FEATUREONLY_ACV_PCNT_UseBounds",
    name: "Feat ACV",
    sort: 6,
    renderOptions: {},
    components: [
        {
            id: "MERCH_FEATUREONLY_ACV_PCNT_InsideBounds",
            name: "InsideBounds Feat ACV",
            metricFieldName: "MERCH_FEATUREONLY_ACV_PCNT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREONLY_ACV_PCNT_InsideBounds": '*' },
                        properties: { color: "#7CFF9F", lineColor: "#7CFF9F", lineType: "line" },
                        displayName: "Event Feat ACV"
                    }
                }
            }
        },
        {
            id: "MERCH_FEATUREONLY_ACV_PCNT_OutsideBounds",
            name: "OutsideBounds Feat ACV",
            metricFieldName: "MERCH_FEATUREONLY_ACV_PCNT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREONLY_ACV_PCNT_OutsideBounds": '*' },
                        properties: { color: "#7CFF9F", lineColor: "#7CFF9F", lineType: "line", pattern: "noFill" },
                        displayName: "Non-Event Feat ACV"
                    }
                }
            }
        }
    ]
}


//mtrc.MERCH_DISPLAYONLY_ACV_PCNT Bounds
const MERCH_DISPLAYONLY_ACV_PCNT_UseBounds: IGraphMetric = {
    id: "MERCH_DISPLAYONLY_ACV_PCNT_UseBounds",
    name: "Disp ACV",
    sort: 7,
    renderOptions: {},
    components: [
        {
            id: "MERCH_DISPLAYONLY_ACV_PCNT_InsideBounds",
            name: "InsideBounds Disp ACV",
            metricFieldName: "MERCH_DISPLAYONLY_ACV_PCNT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_DISPLAYONLY_ACV_PCNT_InsideBounds": '*' },
                        properties: { color: "#0092B2", lineColor: "#0092B2", lineType: "line" },
                        displayName: "Event Disp ACV"
                    }
                }
            }
        },
        {
            id: "MERCH_DISPLAYONLY_ACV_PCNT_OutsideBounds",
            name: "OutsideBounds Disp ACV",
            metricFieldName: "MERCH_DISPLAYONLY_ACV_PCNT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_DISPLAYONLY_ACV_PCNT_OutsideBounds": '*' },
                        properties: { color: "#0092B2", lineColor: "#0092B2", lineType: "line", pattern: "noFill" },
                        displayName: "Non-Event Disp ACV"
                    }
                }
            }
        }
    ]
}


//mtrc.MERCH_TPRONLY_ACV_PCNT Bounds
const MERCH_TPRONLY_ACV_PCNT_UseBounds: IGraphMetric = {
    id: "MERCH_TPRONLY_ACV_PCNT_UseBounds",
    name: "TPR ACV",
    sort: 8,
    renderOptions: {},
    components: [
        {
            id: "MERCH_TPRONLY_ACV_PCNT_InsideBounds",
            name: "InsideBounds TPR ACV",
            metricFieldName: "MERCH_TPRONLY_ACV_PCNT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_TPRONLY_ACV_PCNT_InsideBounds": '*' },
                        properties: { color: "#FF7800", lineColor: "#FF7800", lineType: "line" },
                        displayName: "Event TPR ACV"
                    }
                }
            }
        },
        {
            id: "MERCH_TPRONLY_ACV_PCNT_OutsideBounds",
            name: "OutsideBounds TPR ACV",
            metricFieldName: "MERCH_TPRONLY_ACV_PCNT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "MERCH_TPRONLY_ACV_PCNT_OutsideBounds": '*' },
                        properties: { color: "#FF7800", lineColor: "#FF7800", lineType: "line", pattern: "noFill" },
                        displayName: "Non-Event TPR ACV"
                    }
                }
            }
        }
    ]
}


//</editor-fold>


export const StdMerchadisingACVAxis: IGraphAxis = {
    id: "MerchandisingACV",
    name: "Merchandising ACV",
    renderOptions: {
        ui5: {
            resourceName: "StandardMerchandisingACVAxisName",
            vizPropertiesAxis: {
                label: {
                    formatString: "0\\%"
                },
                title: {
                    visible: true,
                    text: "ACV"
                }
            },
            vizPropertiesPlotArea: {
                "line": { "marker": { "shape": "diamond" }, visible: false }
            }
        }
    },
    metrics: [
        MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds,
        MERCH_FEATUREONLY_ACV_PCNT_UseBounds,
        MERCH_DISPLAYONLY_ACV_PCNT_UseBounds,
        MERCH_TPRONLY_ACV_PCNT_UseBounds
    ],
    defaultRenderedMetricIds: [
        MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds.id,
        MERCH_FEATUREONLY_ACV_PCNT_UseBounds.id,
        MERCH_DISPLAYONLY_ACV_PCNT_UseBounds.id,
        MERCH_TPRONLY_ACV_PCNT_UseBounds.id
    ]

}


//</editor-fold>

//<editor-fold desc="Merchandising ACV Axis - Bar">

//<editor-fold desc="Merchandising ACV Axis - Metrics - Bar">
//mtrc.MERCH_FEATUREDISPLAY_ACV_PCNT
export const MERCH_FEATUREDISPLAY_ACV_PCNT: IGraphMetric = {
    id: "MERCH_FEATUREDISPLAY_ACV_PCNT",
    name: "F&D ACV",
    sort: 5,
    renderOptions: {},
    components: [
        {
            id: "MERCH_FEATUREDISPLAY_ACV_PCNT",
            name: "F&D ACV",
            metricFieldName: "MERCH_FEATUREDISPLAY_ACV_PCNT",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREDISPLAY_ACV_PCNT": '*' },
                        properties: { color: "#B03BB2" },
                        displayName: "F&D ACV"
                    }
                }
            }
        }
    ]
}

//mtrc.MERCH_FEATUREONLY_ACV_PCNT
const MERCH_FEATUREONLY_ACV_PCNT: IGraphMetric = {
    id: "MERCH_FEATUREONLY_ACV_PCNT",
    name: "Feat ACV",
    sort: 6,
    renderOptions: {},
    components: [
        {
            id: "MERCH_FEATUREONLY_ACV_PCNT",
            name: "Feat ACV",
            metricFieldName: "MERCH_FEATUREONLY_ACV_PCNT",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_FEATUREONLY_ACV_PCNT": '*' },
                        properties: { color: "#7CFF9F" },
                        displayName: "Feat ACV"
                    }
                }
            }
        }
    ]
}


//mtrc.MERCH_DISPLAYONLY_ACV_PCNT
const MERCH_DISPLAYONLY_ACV_PCNT: IGraphMetric = {
    id: "MERCH_DISPLAYONLY_ACV_PCNT",
    name: "Disp ACV",
    sort: 7,
    renderOptions: {},
    components: [
        {
            id: "MERCH_DISPLAYONLY_ACV_PCNT",
            name: "Disp ACV",
            metricFieldName: "MERCH_DISPLAYONLY_ACV_PCNT",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_DISPLAYONLY_ACV_PCNT": '*' },
                        properties: { color: "#0092B2" },
                        displayName: "Disp ACV"
                    }
                }
            }
        }
    ]
}


//mtrc.MERCH_TPRONLY_ACV_PCNT
const MERCH_TPRONLY_ACV_PCNT: IGraphMetric = {
    id: "MERCH_TPRONLY_ACV_PCNT",
    name: "TPR ACV",
    sort: 8,
    renderOptions: {},
    components: [
        {
            id: "MERCH_TPRONLY_ACV_PCNT",
            name: "TPR ACV",
            metricFieldName: "MERCH_TPRONLY_ACV_PCNT",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "MERCH_TPRONLY_ACV_PCNT": '*' },
                        properties: { color: "#FF7800" },
                        displayName: "TPR ACV"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const StdMerchadisingACVAxis_Bars: IGraphAxis = {
    id: "MerchandisingACVBar",
    name: "Merchadising ACV (Bar)",
    renderOptions: {
        ui5: {
            resourceName: "StandardMerchandisingACVAxisName",
            vizPropertiesAxis: {
                label: {
                    formatString: "0\\%"
                },
                title: {
                    visible: true,
                    text: "ACV"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [
        MERCH_FEATUREDISPLAY_ACV_PCNT,
        MERCH_FEATUREONLY_ACV_PCNT,
        MERCH_DISPLAYONLY_ACV_PCNT,
        MERCH_TPRONLY_ACV_PCNT
    ],
    defaultRenderedMetricIds: [
        MERCH_FEATUREDISPLAY_ACV_PCNT.id,
        MERCH_FEATUREONLY_ACV_PCNT.id,
        MERCH_DISPLAYONLY_ACV_PCNT.id,
        MERCH_TPRONLY_ACV_PCNT.id
    ]

}

//</editor-fold>

//<editor-fold desc="Retail Sales Axis">

//<editor-fold desc="Retail Sales Axis - Metrics">

const CNSMP_INCR_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_RTLSLS_UseBounds",
    name: "Merch Incr Retail Sales",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_INCR_RTLSLS_InsideBounds",
            name: "InsideBounds Merch Incr Retail Sales",
            metricFieldName: "CNSMP_INCR_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_RTLSLS_InsideBounds": '*' },
                        properties: { color: "#CBF4C9" },
                        displayName: "Event Merch Incr Retail Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_INCR_RTLSLS_OutsideBounds",
            name: "OutsideBounds Merch Incr Retail Sales",
            metricFieldName: "CNSMP_INCR_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_RTLSLS_OutsideBounds": '*' },
                        properties: { color: "#CBF4C9", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Merch Incr Retail Sales"
                    }
                }
            }
        }
    ]
}

const CNSMP_DISP_INCR_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_DISP_INCR_RTLSLS_UseBounds",
    name: "Display Incr Retail Sales",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_DISP_INCR_RTLSLS_InsideBounds",
            name: "InsideBounds Display Incr Retail Sales",
            metricFieldName: "CNSMP_DISP_INCR_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_RTLSLS_InsideBounds": '*' },
                        properties: { color: "#0092B2" },
                        displayName: "Event Disp Incr Retail Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_DISP_INCR_RTLSLS_OutsideBounds",
            name: "OutsideBounds Display Incr Retail Sales",
            metricFieldName: "CNSMP_DISP_INCR_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_RTLSLS_OutsideBounds": '*' },
                        properties: { color: "#0092B2", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Disp Incr Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_RTLSLS_UseBounds",
    name: "EDLP Retail Sales",
    sort: 20,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_EDLP_RTLSLS_InsideBounds",
            name: "InsideBounds EDLP Retail Sales",
            metricFieldName: "CNSMP_EDLP_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_RTLSLS_InsideBounds": '*' },
                        properties: { color: "#0080FF" },
                        displayName: "Event EDLP Retail Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_EDLP_RTLSLS_OutsideBounds",
            name: "OutsideBounds EDLP Retail Sales",
            metricFieldName: "CNSMP_EDLP_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_RTLSLS_OutsideBounds": '*' },
                        properties: { color: "#0080FF", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event EDLP Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_RTLSLS_UseBounds",
    name: "True Base Retail Sales",
    sort: 40,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_BASE_RTLSLS_InsideBounds",
            name: "InsideBounds Base Retail Sales",
            metricFieldName: "CNSMP_BASE_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_RTLSLS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Base Retail Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_BASE_RTLSLS_OutsideBounds",
            name: "OutsideBounds Base Retail Sales",
            metricFieldName: "CNSMP_BASE_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_RTLSLS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Base Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_RTLSLS_UseBounds",
    name: "Synd Base Retail Sales",
    sort: 30,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_SYND_BASE_RTLSLS_InsideBounds",
            name: "InsideBounds Synd Base Retail Sales",
            metricFieldName: "CNSMP_SYND_BASE_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_RTLSLS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Synd Base Retail Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_SYND_BASE_RTLSLS_OutsideBounds",
            name: "OutsideBounds Synd Base Retail Sales",
            metricFieldName: "CNSMP_SYND_BASE_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_RTLSLS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Synd Base Retail Sales"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const StdRtlSlsAxis: IGraphAxis = {
    id: "RtlSls",
    name: "Retail Sales",
    renderOptions: {
        ui5: {
            resourceName: "StandardRetailSalesAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Retail Sales"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_RTLSLS_UseBounds, CNSMP_DISP_INCR_RTLSLS_UseBounds, CNSMP_EDLP_RTLSLS_UseBounds, CNSMP_BASE_RTLSLS_UseBounds, CNSMP_SYND_BASE_RTLSLS_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_RTLSLS_UseBounds.id,
        CNSMP_DISP_INCR_RTLSLS_UseBounds.id,
        CNSMP_EDLP_RTLSLS_UseBounds.id,
        CNSMP_BASE_RTLSLS_UseBounds.id
    ]


}

//</editor-fold>

//<editor-fold desc="List Sales Axis">

//<editor-fold desc="List Sales Axis - Metrics">

const CNSMP_INCR_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_LISTSLS_UseBounds",
    name: "Merch Incr List Sales",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_INCR_LISTSLS_InsideBounds",
            name: "InsideBounds Merch Incr List Sales",
            metricFieldName: "CNSMP_INCR_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_LISTSLS_InsideBounds": '*' },
                        properties: { color: "#CBF4C9" },
                        displayName: "Event Merch Incr List Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_INCR_LISTSLS_OutsideBounds",
            name: "OutsideBounds Merch Incr List Sales",
            metricFieldName: "CNSMP_INCR_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_LISTSLS_OutsideBounds": '*' },
                        properties: { color: "#CBF4C9", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Merch Incr List Sales"
                    }
                }
            }
        }
    ]
}

const CNSMP_DISP_INCR_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_DISP_INCR_LISTSLS_UseBounds",
    name: "Disp Incr List Sales",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_DISP_INCR_LISTSLS_InsideBounds",
            name: "InsideBounds Disp Incr List Sales",
            metricFieldName: "CNSMP_DISP_INCR_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_LISTSLS_InsideBounds": '*' },
                        properties: { color: "#0092B2" },
                        displayName: "Event Disp Incr List Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_DISP_INCR_LISTSLS_OutsideBounds",
            name: "OutsideBounds Disp Incr List Sales",
            metricFieldName: "CNSMP_DISP_INCR_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_LISTSLS_OutsideBounds": '*' },
                        properties: { color: "#0092B2", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Disp Incr List Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_LISTSLS_UseBounds",
    name: "EDLP List Sales",
    sort: 20,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_EDLP_LISTSLS_InsideBounds",
            name: "InsideBounds EDLP List Sales",
            metricFieldName: "CNSMP_EDLP_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_LISTSLS_InsideBounds": '*' },
                        properties: { color: "#0080FF" },
                        displayName: "Event EDLP List Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_EDLP_LISTSLS_OutsideBounds",
            name: "OutsideBounds EDLP List Sales",
            metricFieldName: "CNSMP_EDLP_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_LISTSLS_OutsideBounds": '*' },
                        properties: { color: "#0080FF", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event EDLP List Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_RTLSLS_UseBounds",
    name: "True Base List Sales",
    sort: 40,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_BASE_LISTSLS_InsideBounds",
            name: "InsideBounds Base List Sales",
            metricFieldName: "CNSMP_BASE_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_LISTSLS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Base List Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_BASE_LISTSLS_OutsideBounds",
            name: "OutsideBounds Base List Sales",
            metricFieldName: "CNSMP_BASE_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_LISTSLS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Base List Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_LISTSLS_UseBounds",
    name: "Synd Base List Sales",
    sort: 30,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_SYND_BASE_LISTSLS_InsideBounds",
            name: "InsideBounds Synd Base List Sales",
            metricFieldName: "CNSMP_SYND_BASE_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_LISTSLS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Synd Base List Sales"
                    }
                }
            }
        },
        {
            id: "CNSMP_SYND_BASE_LISTSLS_OutsideBounds",
            name: "OutsideBounds Synd Base List Sales",
            metricFieldName: "CNSMP_SYND_BASE_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_LISTSLS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Synd Base List SalesS"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const StdListSlsAxis: IGraphAxis = {
    id: "ListSls",
    name: "List Sales",
    renderOptions: {
        ui5: {
            resourceName: "StandardListSalesAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "List Sales"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_LISTSLS_UseBounds, CNSMP_DISP_INCR_LISTSLS_UseBounds, CNSMP_EDLP_LISTSLS_UseBounds, CNSMP_BASE_LISTSLS_UseBounds, CNSMP_SYND_BASE_LISTSLS_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_LISTSLS_UseBounds.id,
        CNSMP_DISP_INCR_LISTSLS_UseBounds.id,
        CNSMP_EDLP_LISTSLS_UseBounds.id,
        CNSMP_BASE_LISTSLS_UseBounds.id
    ]


}

//</editor-fold>

//<editor-fold desc="Weight Axis">

//<editor-fold desc="Weight Axis - Metrics">

const CNSMP_INCR_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_WT_UseBounds",
    name: "Incremental Weight",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_INCR_WT_InsideBounds",
            name: "InsideBounds Incr Weight",
            metricFieldName: "CNSMP_INCR_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_WT_InsideBounds": '*' },
                        properties: { color: "#CBF4C9" },
                        displayName: "Event Incr Weight"
                    }
                }
            }
        },
        {
            id: "CNSMP_INCR_WT_OutsideBounds",
            name: "OutsideBounds Incr Weight",
            metricFieldName: "CNSMP_INCR_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_WT_OutsideBounds": '*' },
                        properties: { color: "#CBF4C9", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Incr Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_WT_UseBounds",
    name: "EDLP Weight",
    sort: 20,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_EDLP_WT_InsideBounds",
            name: "InsideBounds EDLP Weight",
            metricFieldName: "CNSMP_EDLP_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_WT_InsideBounds": '*' },
                        properties: { color: "#0080FF" },
                        displayName: "Event EDLP Weight"
                    }
                }
            }
        },
        {
            id: "CNSMP_EDLP_WT_OutsideBounds",
            name: "OutsideBounds EDLP Weight",
            metricFieldName: "CNSMP_EDLP_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_WT_OutsideBounds": '*' },
                        properties: { color: "#0080FF", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event EDLP Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_WT_UseBounds",
    name: "True Base Weight",
    sort: 40,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_BASE_WT_InsideBounds",
            name: "InsideBounds Base Weight",
            metricFieldName: "CNSMP_BASE_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_WT_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Base Weight"
                    }
                }
            }
        },
        {
            id: "CNSMP_BASE_WT_OutsideBounds",
            name: "OutsideBounds Base Weight",
            metricFieldName: "CNSMP_BASE_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_WT_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Base Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_WT_UseBounds",
    name: "Synd Base Weight",
    sort: 30,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_SYND_BASE_WT_InsideBounds",
            name: "InsideBounds Synd Base Weight",
            metricFieldName: "CNSMP_SYND_BASE_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_WT_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Synd Base Weight"
                    }
                }
            }
        },
        {
            id: "CNSMP_SYND_BASE_WT_OutsideBounds",
            name: "OutsideBounds Synd Base Weight",
            metricFieldName: "CNSMP_SYND_BASE_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_WT_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Synd Base Weight"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const StdWeightAxis: IGraphAxis = {
    id: "Weight",
    name: "Weight",
    renderOptions: {
        ui5: {
            resourceName: "StandardWeightAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Weight"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_WT_UseBounds, CNSMP_EDLP_WT_UseBounds, CNSMP_BASE_WT_UseBounds, CNSMP_SYND_BASE_WT_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_WT_UseBounds.id,
        CNSMP_EDLP_WT_UseBounds.id,
        CNSMP_BASE_WT_UseBounds.id
    ]


}

//</editor-fold>

//<editor-fold desc="Statistical Case Axis">

//<editor-fold desc="Statistical Case Axis - Metrics">

const CNSMP_INCR_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_STAT_UseBounds",
    name: "Merch Incr StatCs",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_INCR_STAT_InsideBounds",
            name: "InsideBounds Merch Incr StatCs",
            metricFieldName: "CNSMP_INCR_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_STAT_InsideBounds": '*' },
                        properties: { color: "#CBF4C9" },
                        displayName: "Event Merch Incr StatCs"
                    }
                }
            }
        },
        {
            id: "CNSMP_INCR_STAT_OutsideBounds",
            name: "OutsideBounds Merch Incr StatCs",
            metricFieldName: "CNSMP_INCR_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_INCR_STAT_OutsideBounds": '*' },
                        properties: { color: "#CBF4C9", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Merch Incr StatCs"
                    }
                }
            }
        }
    ]
}

const CNSMP_DISP_INCR_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_DISP_INCR_STAT_UseBounds",
    name: "Display Incr StatCs",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_DISP_INCR_STAT_InsideBounds",
            name: "InsideBounds Disp Incr StatCs",
            metricFieldName: "CNSMP_DISP_INCR_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_STAT_InsideBounds": '*' },
                        properties: { color: "#0092B2" },
                        displayName: "Event Disp Incr StatCs"
                    }
                }
            }
        },
        {
            id: "CNSMP_DISP_INCR_STAT_OutsideBounds",
            name: "OutsideBounds Disp Incr StatCs",
            metricFieldName: "CNSMP_DISP_INCR_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_DISP_INCR_STAT_OutsideBounds": '*' },
                        properties: { color: "#0092B2", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Disp Incr StatCs"
                    }
                }
            }
        }
    ]
}

const CNSMP_EDLP_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_STAT_UseBounds",
    name: "EDLP StatCs",
    sort: 20,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_EDLP_STAT_InsideBounds",
            name: "InsideBounds EDLP StatCs",
            metricFieldName: "CNSMP_EDLP_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_STAT_InsideBounds": '*' },
                        properties: { color: "#0080FF" },
                        displayName: "Event EDLP StatCs"
                    }
                }
            }
        },
        {
            id: "CNSMP_EDLP_STAT_OutsideBounds",
            name: "OutsideBounds EDLP StatCs",
            metricFieldName: "CNSMP_EDLP_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_EDLP_STAT_OutsideBounds": '*' },
                        properties: { color: "#0080FF", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event EDLP StatCs"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_STAT_UseBounds",
    name: "True Base StatCs",
    sort: 40,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_BASE_STAT_InsideBounds",
            name: "InsideBounds Base StatCs",
            metricFieldName: "CNSMP_BASE_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_STAT_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Base StatCs"
                    }
                }
            }
        },
        {
            id: "CNSMP_BASE_STAT_OutsideBounds",
            name: "OutsideBounds Base StatCs",
            metricFieldName: "CNSMP_BASE_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_BASE_STAT_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Base StatCs"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_STAT_UseBounds",
    name: "Synd Base StatCs",
    sort: 30,
    renderOptions: {},
    components: [
        {
            id: "CNSMP_SYND_BASE_STAT_InsideBounds",
            name: "InsideBounds Synd Base StatCs",
            metricFieldName: "CNSMP_SYND_BASE_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_STAT_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Synd Base StatCs"
                    }
                }
            }
        },
        {
            id: "CNSMP_SYND_BASE_STAT_OutsideBounds",
            name: "OutsideBounds Synd Base StatCs",
            metricFieldName: "CNSMP_SYND_BASE_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "CNSMP_SYND_BASE_STAT_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Synd Base StatCs"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const StdStatAxis: IGraphAxis = {
    id: "StatCs",
    name: "Statistical Case",
    renderOptions: {
        ui5: {
            resourceName: "StandardStatAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Statistical Case"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_STAT_UseBounds, CNSMP_DISP_INCR_STAT_UseBounds, CNSMP_EDLP_STAT_UseBounds, CNSMP_BASE_STAT_UseBounds, CNSMP_SYND_BASE_STAT_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_STAT_UseBounds.id,
        CNSMP_DISP_INCR_STAT_UseBounds.id,
        CNSMP_EDLP_STAT_UseBounds.id,
        CNSMP_BASE_STAT_UseBounds.id
    ]


}

//</editor-fold>
//<editor-fold desc="Shipment Units Axis - Metrics">
const SHIPMENT_UNITS_UseBounds: IGraphMetric = {
    id: "SHIPMENT_UNITS_UseBounds",
    name: "Shipment Units",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "SHIPMENT_UNITS_InsideBounds",
            name: "Event Shipment Units",
            metricFieldName: "SHIPMENT_UNITS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_UNITS_InsideBounds": '*' },
                        properties: { color: "#CBF4C9" },
                        displayName: "Event Shipment Units"
                    }
                }
            }
        },
        {
            id: "SHIPMENT_UNITS_OutsideBounds",
            name: "OutsideBounds Shipment Units",
            metricFieldName: "SHIPMENT_UNITS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_UNITS_OutsideBounds": '*' },
                        properties: { color: "#CBF4C9", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Shipment Units"
                    }
                }
            }
        }
    ]
}

export const StdShipUnitsAxis: IGraphAxis = {
    id: "ShipUnits",
    name: "Units",
    renderOptions: {
        ui5: {
            resourceName: "StandardConsumerUnitsAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Shipment Metrics"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [SHIPMENT_UNITS_UseBounds],
    defaultRenderedMetricIds: [
        SHIPMENT_UNITS_UseBounds.id]
}

const SHIPMENT_ORDER_QTY_UseBounds: IGraphMetric = {
    id: "SHIPMENT_ORDER_QTY_UseBounds",
    name: "Ordered Quantity",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "SHIPMENT_ORDER_QTY_InsideBounds",
            name: "InsideBounds Ordered Quantity",
            metricFieldName: "SHIPMENT_ORDER_QTY",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_ORDER_QTY_InsideBounds": '*' },
                        properties: { color: "#0092B2" },
                        displayName: "Event Ordered Quantity"
                    }
                }
            }
        },
        {
            id: "SHIPMENT_ORDER_QTY_OutsideBounds",
            name: "OutsideBounds Ordered Quantity",
            metricFieldName: "SHIPMENT_ORDER_QTY",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_ORDER_QTY_OutsideBounds": '*' },
                        properties: { color: "#0092B2", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Ordered Quantity"
                    }
                }
            }
        }
    ]
}

export const StdShipUnitsOrderAxis: IGraphAxis = {
    id: "ShipUnitsOrder",
    name: "Order Quantity",
    renderOptions: {
        ui5: {
            resourceName: "StandardConsumerUnitsAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Shipment Metrics"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [SHIPMENT_ORDER_QTY_UseBounds],
    defaultRenderedMetricIds: [
        SHIPMENT_ORDER_QTY_UseBounds.id]
}


//</editor-fold>
const SHIPMENT_LISTSLS_UseBounds: IGraphMetric = {
    id: "SHIPMENT_LISTSLS_UseBounds",
    name: "List Sales",
    sort: 40,
    renderOptions: {},
    components: [
        {
            id: "SHIPMENT_LISTSLS_InsideBounds",
            name: "InsideBounds List Sales",
            metricFieldName: "SHIPMENT_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_LISTSLS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event List Sales"
                    }
                }
            }
        },
        {
            id: "SHIPMENT_LISTSLS_OutsideBounds",
            name: "OutsideBounds List Sales",
            metricFieldName: "SHIPMENT_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_LISTSLS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event List Sales"
                    }
                }
            }
        }
    ]
}

const SHIPMENT_NETLISTSLS_UseBounds: IGraphMetric = {
    id: "SHIPMENT_NETLISTSLS_UseBounds",
    name: "Net List Sales",
    sort: 30,
    renderOptions: {},
    components: [
        {
            id: "SHIPMENT_NETLISTSLS_InsideBounds",
            name: "InsideBounds Net List Sales",
            metricFieldName: "SHIPMENT_NETLISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_NETLISTSLS_InsideBounds": '*' },
                        properties: { color: "#A59487" },
                        displayName: "Event Net List Sales"
                    }
                }
            }
        },
        {
            id: "SHIPMENT_NETLISTSLS_OutsideBounds",
            name: "OutsideBounds Net List Sales",
            metricFieldName: "SHIPMENT_NETLISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_NETLISTSLS_OutsideBounds": '*' },
                        properties: { color: "#A59487", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Net List Sales"
                    }
                }
            }
        }
    ]
}

const SHIPMENT_PRFTCNTRB_UseBounds: IGraphMetric = {
    id: "SHIPMENT_PRFTCNTRB_UseBounds",
    name: "Profit Contribution",
    sort: 10,
    renderOptions: {},
    components: [
        {
            id: "SHIPMENT_PRFTCNTRB_InsideBounds",
            name: "Event Profit Contribution",
            metricFieldName: "SHIPMENT_PRFTCNTRB",
            periodMetricsPath: "InsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_PRFTCNTRB_InsideBounds": '*' },
                        properties: { color: "#CBF4C9" },
                        displayName: "Event Profit"
                    }
                }
            }
        },
        {
            id: "SHIPMENT_PRFTCNTRB_OutsideBounds",
            name: "OutsideBounds Profit Contribution",
            metricFieldName: "SHIPMENT_PRFTCNTRB",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {
                ui5: {
                    dataShape: "bar",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_PRFTCNTRB_OutsideBounds": '*' },
                        properties: { color: "#CBF4C9", pattern: "diagonalLightStripe" },
                        displayName: "Non-Event Profit Contribution"
                    }
                }
            }
        }
    ]
}
export const StdShipListSlsAxis: IGraphAxis = {
    id: "ShipListSls",
    name: "List Sales",
    renderOptions: {
        ui5: {
            resourceName: "StandardListSalesAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "List Sales"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [SHIPMENT_LISTSLS_UseBounds, SHIPMENT_NETLISTSLS_UseBounds, SHIPMENT_PRFTCNTRB_UseBounds],
    defaultRenderedMetricIds: [
        SHIPMENT_LISTSLS_UseBounds.id

    ]
}


export const SHIPMENT_LIST_PRICE: IGraphMetric = {
    id: "SHIPMENT_LIST_PRICE",
    name: "List Price",
    sort: 260,
    renderOptions: { ui5: { resourceName: "mtrcListPrice" } },
    components: [
        {
            id: "SHIPMENT_LIST_PRICE",
            name: "List Price",
            metricFieldName: "SHIPMENT_LIST_PRICE",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_LIST_PRICE": '*' },
                        properties: { color: "#91FFBA", lineColor: "#91FFBA", lineType: "line" },
                        displayName: "List Price"
                    }
                }
            }
        }
    ]
}

export const SHIPMENT_INVOICE_PRICE: IGraphMetric = {
    id: "SHIPMENT_INVOICE_PRICE",
    name: "Invoice Price",
    sort: 260,
    renderOptions: { ui5: { resourceName: "mtrcListPrice" } },
    components: [
        {
            id: "SHIPMENT_INVOICE_PRICE",
            name: "Invoice Price",
            metricFieldName: "SHIPMENT_INVOICE_PRICE",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_INVOICE_PRICE": '*' },
                        properties: { color: "#91FFBA", lineColor: "#91FFBA", lineType: "line" },
                        displayName: "Invoice Price"
                    }
                }
            }
        }
    ]
}


export const StdShipPricesAxis: IGraphAxis = {
    id: "ShipPrices",
    name: "Prices",
    renderOptions: {
        ui5: {
            resourceName: "StandardPricesAxisName",
            vizPropertiesAxis: {
                label: {
                    formatString: "0.00"
                },
                title: {
                    visible: true,
                    text: "Price"
                }
            },
            vizPropertiesPlotArea: {
                "line": { "marker": { "shape": "diamond" } }
            }
        }
    },
    metrics: [SHIPMENT_LIST_PRICE, SHIPMENT_INVOICE_PRICE],
    defaultRenderedMetricIds: [
        SHIPMENT_LIST_PRICE.id]

}


export const SHIPMENT_LIST_PRICE_ORDER: IGraphMetric = {
    id: "SHIPMENT_LIST_PRICE_ORDER",
    name: "List Price Per Order UOM",
    sort: 260,
    renderOptions: { ui5: { resourceName: "mtrcListPrice" } },
    components: [
        {
            id: "SHIPMENT_LIST_PRICE_ORDER",
            name: "List Price",
            metricFieldName: "SHIPMENT_LIST_PRICE_ORDER",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_LIST_PRICE_ORDER": '*' },
                        properties: { color: "#91FFBA", lineColor: "#91FFBA", lineType: "line" },
                        displayName: "List Price Per Order UOM"
                    }
                }
            }
        }
    ]
}

export const SHIPMENT_INVOICE_PRICE_ORDER: IGraphMetric = {
    id: "SHIPMENT_INVOICE_PRICE_ORDER",
    name: "Invoice Price Per Order UOM",
    sort: 260,
    renderOptions: { ui5: { resourceName: "mtrcListPrice" } },
    components: [
        {
            id: "SHIPMENT_INVOICE_PRICE_ORDER",
            name: "Invoice Price",
            metricFieldName: "SHIPMENT_INVOICE_PRICE_ORDER",
            periodMetricsPath: "Total",
            renderOptions: {
                ui5: {
                    dataShape: "line",
                    dataPointRule: {
                        dataContext: { "SHIPMENT_INVOICE_PRICE_ORDER": '*' },
                        properties: { color: "#91FFBA", lineColor: "#91FFBA", lineType: "line" },
                        displayName: "Invoice Price Per Order UOM"
                    }
                }
            }
        }
    ]
}


export const StdShipPricesOrderAxis: IGraphAxis = {
    id: "ShipPricesOrder",
    name: "Prices",
    renderOptions: {
        ui5: {
            resourceName: "StandardPricesAxisName",
            vizPropertiesAxis: {
                label: {
                    formatString: "0.00"
                },
                title: {
                    visible: true,
                    text: "Price"
                }
            },
            vizPropertiesPlotArea: {
                "line": { "marker": { "shape": "diamond" } }
            }
        }
    },
    metrics: [SHIPMENT_LIST_PRICE_ORDER, SHIPMENT_INVOICE_PRICE_ORDER],
    defaultRenderedMetricIds: [
        SHIPMENT_LIST_PRICE_ORDER.id]

}

export const FullStandardAxisList: IGraphAxis[] = [
    StdUnitsAxis,
    StdPricesAxis,
    StdMerchadisingUnitsAxis,
    StdMerchadisingACVAxis,
    StdRtlSlsAxis,
    StdListSlsAxis,
    StdWeightAxis,
    StdStatAxis,
    StdShipUnitsAxis,
    StdShipUnitsOrderAxis,
    StdShipPricesAxis,
    StdShipListSlsAxis,
    StdShipPricesOrderAxis
]

